(function AdzukiModal($, Adzuki)
{
	'use strict';

	const { markRaw } = Vue;

	const component = {
		emits: ['close-modal', 'component-event'],
		props: {
			modalTitle: {
				type    : String,
				required: false,
			},
			type: {
				type     : String,
				required : true,
				validator: value => ['component', 'html'].includes(value),
			},
			componentName: {
				type: [String, Object],
				validator(value, props) {
					if (props && props.type === 'component') {
						return Boolean(value);
					}
					return true;
				}
			},
			componentProps: {
				type: Object
			},
			htmlContent: {
				type: String,
				validator(value, props) {
					if (props && props.type === 'html') {
						return Boolean(value);
					}
					return true;
				}
			},
			section: {
				type: String
			}
		},
		template: `
          <div class="modal-component" ref="modalComponent" @click="tryToCloseModal" :class="{'erez-vue-modal': this.section}">
            <div class="modal-component-content">
              <div class="modal-component-header">
                <span class="close" @click="closeModal">&times;</span>
				  <h4 v-if="modalTitle && !modalTitleContainsHtml">{{ modalTitle }}</h4>
				  <span v-else v-html="modalTitle"></span>
              </div>
              <div class="modal-component-body">
				<template v-if="type === 'component'">
					<component
						:is="componentName"
						v-bind="componentProps"
						@component-event="$emit('component-event', $event)"
						@close-modal="closeModal"
					></component>
                </template>
				<template v-else>
				  <div v-html="htmlContent"></div>
				</template>
              </div>
            </div>
          </div>
		`,
		data() {
			return {
			};
		},
		computed: {
			modalTitleContainsHtml() {
				if (!this.modalTitle) {
					return false;
				}
				// DOMParser: if parsing yields element nodes, treat as HTML
				const doc = new DOMParser().parseFromString(this.modalTitle, 'text/html');
				return doc.body.children.length > 0;
			},
		},
		methods: {
			closeModal() {
				this.$emit('close-modal');
			},
			componentEvent(event) {
				this.$emit('component-event', event);
			},
			tryToCloseModal(event) {
				if (event.target === this.$refs.modalComponent) {
					this.closeModal();
				}
			}
		},
		watch: {
			componentName(newVal) {
				if (newVal && typeof newVal === 'object' && !Object.isFrozen(newVal)) {
					this.componentName = markRaw(newVal);
				}
			}
		},
	};

	Adzuki.VueComponents.AdzukiModal = component;
}(jQuery, window.Adzuki || {}));
